import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import importListHelper from '../../../Helpers/importListHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import selectHelper from '../../../Helpers/selectHelper';

export default class TpJobSearchParams extends SearchParamsBase {
  initialize() {
    this.TpJobId = '';
    this.ThirdPartyJobId = '';
    this.ThirdPartyEvaluatorId = '';
    this.ThirdPartySources = [];
    this.SelectedCaspianClientIds = [];
    this.ThirdPartyLocationName = '';
    this.ThirdPartyJobStatus = '';
    this.SelectedFieldworkOfficeIds = [];
    this.UseAssignedDateRange = false;
    this.DateAssignedFrom = dateTimeHelper.indefiniteDateValue();
    this.DateAssignedTo = dateTimeHelper.indefiniteDateValue();
    this.OrphanedMissingClient = false;
    this.OrphanedMissingSurveyIds = '';
    this.OrphanedMissingProject = false;
    this.OrphanedMissingCompletedDate = false;
    this.OrphanedMissingPricing = false;
    this.MyOfficeUninvoiced = false;
    this.Invoiced = '';
    this.TpSurveyIdOrName = '';
    this.ProjectIdOrName = '';
    this.TpWaveIdOrName = '';
    this.UseCompletedDateRange = false;
    this.DateCompletedFrom = dateTimeHelper.indefiniteDateValue();
    this.DateCompletedTo = dateTimeHelper.indefiniteDateValue();
    this.IsUninvoiceable = '';
    this.PaidOutsideOfSystem = '';
    this.SelfAssigned = '';
    this.BillClient = '';
    this.PayEvaluator = '';
    this.EvaluatorEmail = '';
    this.SelectedThirdPartyJobStatuses = '';
    this.AdHocGroup = '';
    this.SelectedCountryCodes = [];
    this.City = '';
    this.ZipCode = '';
    this.UseDueDateRange = false;
    this.DateDueFrom = dateTimeHelper.indefiniteDateValue();
    this.DateDueTo = dateTimeHelper.indefiniteDateValue();
    this.SchedulerName = '';
    this.OwningOfficeId = '';
    this.PaymentOfficeId = '';
    this.CampaignName = '';
  }

  static tabsOnTheSearchPanel = [
    { label: 'Linking', id: 'linking', icon: 'fa-solid fa-link' },
    { label: 'General', id: 'general', icon: 'fa-solid fa-database' },
    { label: 'Payments', id: 'payments', icon: 'fa-solid fa-file-invoice-dollar' },
    { label: 'Grouping Options', id: 'grouping', icon: 'fa-solid fa-people-group' },
  ];

  static fieldsInSearchBox = [
    {
      fieldName: 'TpJobId',
      label: 'IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'linking',
    },
    {
      fieldName: 'ThirdPartyJobId',
      label: 'Third-Party Job IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'linking',
    },
    {
      fieldName: 'ThirdPartySources',
      label: 'Third Party Sources',
      className: 'col-3',
      type: InputTypesEnum.ThirdPartySourceTpJobMultiChoice,
      tab: 'linking',
    },
    {
      fieldName: 'SelectedCaspianClientIds',
      label: 'Client',
      className: 'col-3',
      type: InputTypesEnum.ClientMultiChoice,
      tab: 'linking',
    },
    {
      fieldName: 'ProjectIdOrName',
      label: 'Project (Name or Third Party ID)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },
    {
      fieldName: 'TpSurveyIdOrName',
      label: 'Survey (Name or Third Party ID)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },
    {
      fieldName: 'TpWaveIdOrName',
      label: 'Wave (Name or Third Party ID)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },
    {
      fieldName: 'SelectedCountryCodes',
      label: 'Countries',
      className: 'col-3',
      type: InputTypesEnum.CountryCodeMultiChoice,
      tab: 'linking',
    },
    {
      fieldName: 'City',
      label: 'City',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },
    {
      fieldName: 'ZipCode',
      label: 'Zip Codes',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText:
        'One zip code matches partially; a list matches each code exactly. Separate them with commas, or paste a column from Excel with the list button',
      tab: 'linking',
    },
    {
      fieldName: 'CampaignName',
      label: 'Campaign',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'linking',
    },

    {
      fieldName: 'SelectedJobStatuses',
      label: 'Job Status',
      className: 'col-3',
      type: InputTypesEnum.TpJobStatusMultiSelect,
      tab: 'general',
    },
    {
      fieldName: 'ThirdPartyEvaluatorId',
      label: 'Evaluator IDs',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'general',
    },
    {
      fieldName: 'EvaluatorEmail',
      label: 'Evaluator Email',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    {
      fieldName: 'ThirdPartyLocationName',
      label: 'Location (Name or Third Party ID)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    {
      fieldName: 'SelectedThirdPartyJobStatuses',
      label: 'Third Party Job Status',
      className: 'col-3',
      type: InputTypesEnum.TpJobThirdPartyStatusMultiSelect,
    },
    {
      fieldName: 'SelectedFieldworkOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      tab: 'general',
    },
    {
      fieldName: 'OwningOfficeId',
      label: 'Owning Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      tab: 'general',
    },
    {
      fieldName: 'SchedulerName',
      label: 'Scheduler (First Name, Last Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'general',
    },
    {
      fieldName: 'UseAssignedDateRange',
      label: 'Use Assigned Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'general',
    },
    {
      fieldName: 'DateAssignedFrom',
      label: 'Date Assigned From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseAssignedDateRange,
      tab: 'general',
    },
    {
      fieldName: 'DateAssignedTo',
      label: 'Date Assigned To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseAssignedDateRange,
      tab: 'general',
    },
    {
      fieldName: 'UseCompletedDateRange',
      label: 'Use Completed Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'general',
    },
    {
      fieldName: 'DateCompletedFrom',
      label: 'Date Completed From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
      tab: 'general',
    },
    {
      fieldName: 'DateCompletedTo',
      label: 'Date Completed To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCompletedDateRange,
      tab: 'general',
    },
    {
      fieldName: 'UseDueDateRange',
      label: 'Use Due Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'general',
    },
    {
      fieldName: 'DateDueFrom',
      label: 'Date Due From',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDueDateRange,
      tab: 'general',
    },
    {
      fieldName: 'DateDueTo',
      label: 'Date Due To',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDueDateRange,
      tab: 'general',
    },

    {
      fieldName: 'Invoiced',
      label: 'Invoiced',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'IsUninvoiceable',
      label: 'Uninvoiceable',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'PaidOutsideOfSystem',
      label: 'Paid Outside of System',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'SelfAssigned',
      label: 'Self Assigned',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'BillClient',
      label: 'Bill Client',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'PayEvaluator',
      label: 'Pay Shopper',
      className: 'col-3',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'payments',
    },
    {
      fieldName: 'AdHocGroup',
      label: 'Ad-Hoc Invoice Group',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'payments',
    },
    {
      fieldName: 'PaymentOfficeId',
      label: 'Payment Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeOrGroupSelect,
      tab: 'payments',
    },

    {
      fieldName: 'OrphanedMissingClient',
      label: 'Orphaned - Missing Client',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'grouping',
    },
    {
      fieldName: 'OrphanedMissingSurveyIds',
      label: 'Orphaned - Missing Survey IDs',
      className: 'col-3',
      type: InputTypesEnum.Text,
      hide: (item) => !item.OrphanedMissingClient,
      tab: 'grouping',
    },
    {
      fieldName: 'OrphanedMissingProject',
      label: 'Orphaned - Missing Project',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'grouping',
    },
    {
      fieldName: 'OrphanedMissingCompletedDate',
      label: 'Orphaned - Missing Completed Date',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'grouping',
    },
    {
      fieldName: 'OrphanedMissingPricing',
      label: 'Orphaned - Missing Pricing',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'grouping',
    },
    {
      fieldName: 'MyOfficeUninvoiced',
      label: 'My Office Uninvoiced',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
      tab: 'grouping',
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpJobSearchParams';

  static defaultOfficeId = '';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
